module.exports = __webpack_public_path__ + "static/media/unlink.4e833975.svg";